module.exports = __webpack_public_path__ + "static/landing_bg_v5_text-4d848898b830b959a020ed85f9dfebf0.svg";